package com.zq.webproject.model

import kotlinx.serialization.Serializable

/**
 * 投诉响应数据类
 */
@Serializable
data class ComplaintResponse(
    val code: Int,
    val message: String,
    val data: String? = null
)
